import React, { useCallback } from 'react';

import { messagesModel, selectMessages, selectOption } from '@/features';
import { useAppDispatch, useAppSelector, useParametricSelector } from '@/store';

import { TextOption } from './FieldOptions/TextOption';

export const TextOptions: React.FC<{
  messageId: string;
  options: messagesModel.SelectionChoice[];
}> = ({ messageId, options }) => {
  const dispatch = useAppDispatch();

  const selectedOption = useParametricSelector(
    selectMessages.makeSelectedOptionSelector,
    messageId,
  );

  const disabled =
    useAppSelector(selectMessages.newestVisitorOptionsFieldsMessageId) !==
      messageId || Boolean(selectedOption);

  const handleOptionClick = useCallback(
    (option: string) => {
      dispatch(
        selectOption({
          answerTo: messageId,
          option,
        }),
      );
    },
    [dispatch, messageId],
  );
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
      {options.map(({ choice }, idx) => (
        <TextOption
          key={idx}
          onClick={handleOptionClick}
          text={choice}
          selected={choice === selectedOption}
          disabled={disabled}
        />
      ))}
    </div>
  );
};
